const breadcrumbForMobile = (function(){

    const breadcrumbDesktopDOM = document.querySelector('.nlx-site-navigation__breadcrumb-section')
    if(!breadcrumbDesktopDOM) return
    const breadcrumbMobileDOM = breadcrumbDesktopDOM.cloneNode(true)
    breadcrumbMobileDOM.classList.add('nlx-site-navigation__breadcrumb-section--mobile')

    const topheaderDOM = document.querySelector('.nlx-top-header')
    const mainDOM = document.querySelector('MAIN')
    const targetDOM = topheaderDOM || mainDOM
    targetDOM.prepend(breadcrumbMobileDOM)
})()
